import { string } from "yup"
import { getAPI, postAPI, putAPI } from "../../api/api"
import { REACT_APP_CUSTOMER, REACT_APP_CUSTOMERSETTINGS, REACT_APP_JOB, REACT_APP_JOBFILTER, REACT_APP_MESSAGING, REACT_APP_TIMESHEET } from "../../utils/common"



export async function getCandidateTimesheet(pageNumber?: number, pageSize?: number, search?: string, body?: any){
    const Details = postAPI( REACT_APP_TIMESHEET + `/candidate-timesheet-list?page=${pageNumber}&size=${pageSize}&search=${search}`, body)
    return Details
}

export async function updatePaymentSettings(body: any) {
    const Details = putAPI(REACT_APP_CUSTOMER + '/payment-settings', body)
    return Details
}

export async function getPaymentSettings(customerId: string) {
    const Details = getAPI(REACT_APP_CUSTOMER + `/payment-settings/${customerId}`)
    return Details
}

export async function getHolidaysList(customerId: string){
    const Details = getAPI(REACT_APP_CUSTOMER + `/company-holidays/${customerId}`)
    return Details
}

export async function uploadHolidayFile(body: any) {
    const Details = postAPI(REACT_APP_MESSAGING + '/api/excel-data', body)
    return Details
}

export async function getHistory(timesheetId: string) {
    const Details = getAPI( REACT_APP_TIMESHEET + `/getApproveRejectTimesheetHistory/${timesheetId}`)
    return Details
}

export async function sendTimesheetReminder(body: any) {
    const Details = postAPI(REACT_APP_TIMESHEET + '/timesheetSubmitReminder', body)
    return Details
}

export async function getProviderEmailList(candidateId: string) {
    const Details = getAPI(REACT_APP_CUSTOMERSETTINGS + `/getProviderDetails/${candidateId}`)
    return Details
}

export async function getpositionsName() {
    const Details = getAPI(REACT_APP_JOBFILTER + "/position-title")
    return Details
}